import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-navegacao-administrativa',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './navegacao-administrativa.component.html',
  styleUrls: ['./navegacao-administrativa.component.css']
})
export class NavegacaoAdministrativaComponent {
  @Input() aba = 'registrador';
  @Input() adminGlobal = false;
  @Input() ajustesPendentes = 0;
  @Input() feriasPendentes = 0;
  @Output() selecionar = new EventEmitter<string>();
  @Output() menu = new EventEmitter<void>();
  @Output() sair = new EventEmitter<void>();
}
